import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

/**
 * A register prompt across the top of the page, shown only to signed-out
 * visitors. Hidden while the session check is still running so it can't flash
 * in front of someone who is already signed in, and hidden on the register page
 * itself where it would just point at the form already on screen.
 */
function Banner(): JSX.Element | null {
  const { username, loading } = useAuth();
  const { pathname } = useLocation();

  if (loading || username) return null;
  if (pathname === '/signup') return null;

  return (
    <Link to="/signup" className="signup-banner">
      Register Now →
    </Link>
  );
}

export default Banner;
